exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ref-docs-upload-popout-container{background-color:#fff;border:none;box-shadow:0 2px 4px 0 rgba(0,0,0,.33);border-radius:4px;box-sizing:border-box;overflow:visible;padding:24px;position:fixed;left:382px;top:135px;min-height:153px;width:256px;z-index:16;display:flex;flex-direction:column}.ref-docs-upload-popout-container .arrow-up{position:absolute;top:-10px;left:37px;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #fff}.ref-docs-upload-popout-container .uploading-title{font-family:Open Sans,sans-serif;font-size:10px;font-weight:300;font-style:italic;color:#9b9b9b;margin-top:8px}.ref-docs-upload-popout-container .multi-file-uploader__button{right:-12px}.ref-docs-upload-popout-container .multi-file-uploader__button img{height:24px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentsUploader/ReferenceDocumentsUploader.scss
// module id = 1839
// module chunks = 0